import {getCookie, setCookie} from "./cookies";

export const LIGHT = 'light';
export const DARK = 'dark';
const COOKIE_NAME = 'color-scheme';
const COOKIE_DOMAIN = process.env.MIX_SESSION_DOMAIN;
let onChangeListeners = [];

export const current = () => {
    var currentColorScheme = getCookie(COOKIE_NAME);

    if (currentColorScheme === DARK) {
        return DARK;
    }

    return LIGHT;
}

export const toggle = () => {
    var currentColorScheme = getCookie(COOKIE_NAME);

    // Amend the html classes.
    if (currentColorScheme !== DARK) {
        setDark();
        return DARK;
    } else {
        setLight();
        return LIGHT;
    }
}

export const setDark = ()=> {
    $("html").addClass("dark");
    setCookie(COOKIE_NAME, DARK, 365, COOKIE_DOMAIN);
    onThemeChanged(DARK);
}

export const setLight = () => {
    $("html").removeClass("dark");
    setCookie(COOKIE_NAME, LIGHT, 365, COOKIE_DOMAIN);
    onThemeChanged(LIGHT);
}

export const hasThemeCookie = () => {
    var value = getCookie(COOKIE_NAME);
    return value === LIGHT || value === DARK;
}

export const onChange = listener => {
    onChangeListeners.push(listener);
}

export const removeChangeListener = listener => {
    onChangeListeners = onChangeListeners.filter(l => l !== listener);
}

const onThemeChanged = newTheme => {
    for(let i=0,il=onChangeListeners.length; i<il; i++) {
        onChangeListeners[i](newTheme);
    }
}